import { Link } from 'react-router-dom'
import { ROUTES } from '../Routes'
import close from '../assets/close.png'
const Disclaimer = () => {
    return (
        <div
            className="disclaimer bg-[#0b0c15] border-b-[1px] border-[#2f334e] text-[#ffffff] text-center py-[4px] leading-[14px] z-[21] relative text-[13px]">
            <div className="px-[16px] leading-[13px] md:leading-[20px]">
                We receive advertising fees from the brands we review that affect the ranking and scoring. We do not compare
                all service providers in the market.
                <div className="disclaimer-wrapper inline-block">
                    <span className="underline cursor-pointer" data-tracking="disclosure">Advertiser Disclosure</span>
                </div>
                <br />18+."T&C" apply - the applicable operator's terms apply for each offer below and free offers may
                include additional terms.
                <div className="disclaimer-text invisible absolute w-[375px] rounded-[3px] border-[1px] border-[rgba(152,159,170,.49)] z-[300] p-[20px_15px]
                 max-w-full leading-[1.5] text-[14px] text-left text-[#555] bg-white shadow-[0_0_20px_rgba(0,0,0,0.2)] sm:max-w-[430px] sm:w-[95%]"
                    style={{position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate(-253px, 18px)"}} data-popper-placement="bottom-end">
                    <div id="content-area">
                        This website is an informative comparison site that aims to offer its users find helpful information
                        regarding the products and offers that will be suitable for their needs. We are able to maintain a
                        free, high-quality service by receiving advertising fees from the brands and service providers we
                        review on this website (though we may also review brands we are not engaged with). These advertising
                        fees, combined with our criteria and methodology, such as the conversion rates, our team of
                        reviewer's finding and subjective experience and product popularity, impact the placement and
                        position of the brands within the comparison table. In the event rating or scoring are assigned by
                        us, they are based on the position in the comparison table, or according to other formula in the
                        event specifically detailed by us. See our <Link target='_blank' to={ROUTES.HOW_WE_RATE}
                            className='text-link'>How we Rate</Link> page and <Link className='text-link' target='_blank'
                                to={ROUTES.TERMS_AND_CONDITIONS}>Terms of Use</Link> for information. The reviews, rating and scoring
                        are provided “as-is” without guaranties or warranties regarding the information contained in our
                        website, which shall not be considered as endorsement. We make the best efforts to keep the
                        information up-to-date, however, an offer’s terms might change at any time. We do not compare or
                        include all service providers, brands and offers available in the market.
                    </div>
                    <div className="mt-[20px] sm:hidden">
                        <img className="disclaimer-close m-auto border-[1px] border-solid rounded-[50%] p-[9px] w-[50px] h-[50px]"
                            src={close} width="24" height="24" alt="close"
                            loading="lazy" />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Disclaimer